const defaultCdnDomain = 'www.paypalobjects.com';

export const replaceGeoUrl = (url: string, geoAwareDomain?: string) => {
  if (!url || typeof url !== 'string' || !url.includes(defaultCdnDomain)) {
    return url;
  }

  return geoAwareDomain ? url.replace(defaultCdnDomain, geoAwareDomain) : url;
};
